module.exports = __webpack_public_path__ + "img/11-1.86337a35.png";